<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Work Order Entry Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="WO Detail" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <keep-alive>
        <component
          class="flex-1"
          :is="steps[current].content"
          :ref="stepRef"
          v-bind="stepProps"
        ></component>
      </keep-alive>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          :loading="btnLoading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >Save</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Informasi from "./steps/Informasi.vue";
import DetailWO from "./steps/DetailWO.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import shortingArray from "@/mixins/MultishortArray";
import Approval from "./steps/Persetujuan.vue";

export default {
  name: "WOCreate",
  props: ["id"],
  mixins: [CurrencyFormat, shortingArray],
  components: {
    Informasi,
    DetailWO,
    Approval,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "DetailWO",
          content: "DetailWO",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      mode: "Create",
      collectData: {},
      mata_uang: "",
      listWO: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      btnLoading: false,
      kurs: "",
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    initialListItem() {
      let data = [];
      let hargaTotal = 0;
      if (this.mode === "Edit") {
        this.listWO.forEach((item) => {
          hargaTotal = item.values.jumlah * item.values.harga;
          const values = item.values;
          data = [...data, { hargaTotal: hargaTotal, values }];
        });
      } else {
        data = this.listWO;
        this.collectData.listWO.forEach((item) => {
          hargaTotal = item.jumlah * item.harga;
          data = [
            ...data,
            {
              hargaTotal: hargaTotal,
              values: item,
            },
          ];
        });
      }
      return data;
    },
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            listWO: this.listWO,
            mode: this.mode,
            mata_uang: this.mata_uang,
            keuangan: this.collectData.keuangan,
          };
        } else if (this.steps[this.current].content === "DetailWO") {
          return {
            data: this.collectData.informasi,
            listWO: this.listWO,
            mode: "Edit",
            mata_uang: this.mata_uang,
            kurs: this.kurs,
          };
        } else{
          return {
            collectData : this.collectData,
            lisAppr : this.collectData.approval,
            mode: "Edit",
          }
        }
      } else {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            mode: this.mode,
            listWO: this.listWO,
            mata_uang: this.mata_uang,
          };
        } else if (this.steps[this.current].content === "DetailWO") {
          return {
            data: this.collectData.informasi,
            listWO: this.listWO,
            mode: this.mode,
            mata_uang: this.mata_uang,
            kurs: this.kurs,
          };
        } else {
          return {
            collectData : this.collectData,
            lisAppr : this.collectData.approval,
            mode: "Create",
          }
        }
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "DetailWO") {
        return "refDetailWO";
      } else{
        return "refApproval";
      }
    },
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchDetail();
    }
  },
  methods: {
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "DetailWO") {
        this.$refs.refDetailWO.handleRef();
        this.getApproval();
      } else {
        this.$refs.refApproval.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refApproval.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        if (this.mode === "Create") {
          this.collectData.informasi = JSON.parse(
            JSON.stringify(value.informasi)
          );
          //this.collectData.listWO = JSON.parse(JSON.stringify(value.listWO));
        } else {
          this.collectData.informasi = JSON.parse(
            JSON.stringify(value.informasi)
          );

          if (this.collectData.listWO === "undefined") {
            this.collectData.listWO = JSON.parse(JSON.stringify(value.listWO));
          }
        }
        this.mata_uang = value.mata_uang;
        this.kurs = value.informasi.kurs;

        this.current++;
      } else if (this.steps[this.current].content === "DetailWO") {
        if (value.grandtotal == 0) {
          this.displayMessageValue(
              "error-other",
              "Grand Total must be grather than 0"
            );
        } else {
          this.collectData.listWO = JSON.parse(JSON.stringify(value.DetailWO));
          this.collectData.grandtotal = value.grandtotal;

          let validval = this.collectData.listWO.filter(
            (item) => item.is_item == "yes"
          );

          if (validval.length == 0) {
            this.displayMessageValue(
              "error-other",
              "There must be an items category in the detail data!"
            );
          } else {
            // if (this.mode === "Edit") {
            //   let flagSave = this.collectData.keuangan[0].grandTotal*this.collectData.keuangan[0].kurs>=100000000
            //   let flagnom = value.grandtotal*this.collectData.keuangan[0].kurs>=100000000
            //   if(flagSave && flagSave==flagnom){
            //     this.confirmMessage("confirm-edit");
            //   }else{
            //     flagSave
            //     ? this.displayMessageValue("error-other", "Grand Total of modified data must not be less than Rp.100.000.000!")
            //     : this.displayMessageValue("error-other", "Grand Total of modified data should not be more than Rp.100.000.000!")
            //   }
            // } else {
            // }
          }
        }
      }else{
        this.collectData.informasi.catatan = value.note;
        this.confirmMessage("confirm-save");
      }
    },
    getListWO(item) {
      this.listWO = [...this.listWO, JSON.parse(JSON.stringify(item))];
      this.$refs.refDetailWO.recountingBalance(this.listWO, "add");
    },
    getUpdatePekerjaan(item) {
      this.listWO = item;
      this.$refs.refDetailWO.recountingBalance(this.listWO, "add");
      this.listWO = this.ArrshortMultiCol(this.listWO, {
        pp_kode_anggaran: "asc",
      });
    },
    setSubmitForm() {
      if (this.mode === "Edit") {
        let id_dtl = [];
        let job = [];
        let qty = [];
        let satuan = [];
        let harga = [];
        let hargaTotal = [];
        let is_item = [];
        let used_for = [];
        let id_pp_dtl = [];
        let unit_price = [];
        let tax_type = [];
        let catatan_dtl = [];
        let tax_bearer = [];

        this.collectData.listWO.forEach((data) => {
          id_dtl.push(data.values.id_wo_dtl),
            job.push(data.values.item_name),
            qty.push(data.values.jumlah),
            satuan.push(data.values.satuan),
            harga.push(data.values.harga),
            hargaTotal.push(data.values.hargaTotal),
            is_item.push(data.values.is_item),
            used_for.push(data.values.used_for),
            id_pp_dtl.push(
              data.values.selectedPPdtl ? data.values.selectedPPdtl : null
            ),
            unit_price.push(data.values.cur_type);
            tax_type.push(data.values.tax_type);
            catatan_dtl.push(data.values.catatan_dtl);
            tax_bearer.push(data.values.tax_bearer);
        });

        this.postJson = {
          tlc: this.getAuth.username,
          id_manifest: this.collectData.informasi.id_wo,
          tgl_wo: this.collectData.informasi.tgl_buat,
          no_pp: this.collectData.informasi.no_pp,
          id_pp: this.collectData.informasi.id_pp,
          id_supplier: this.collectData.informasi.id_supplier,
          deskripsi: this.collectData.informasi.deskripsi,
          lokasi: this.collectData.informasi.lokasi,

          catatan: this.collectData.informasi.catatan ? 
            this.collectData.informasi.catatan : '',
          tax: this.collectData.informasi.tax,
          tgl_pekerjaan: this.collectData.informasi.tgl_buat,
          bod: this.collectData.informasi.bod,
          tax_transaction: this.collectData.informasi.tax_transaction,
          tax_bearer: tax_bearer,
          //id_dtl: id_dtl,
          job: job,
          qty: qty,
          satuan: satuan,
          harga: harga,
          hargaTotal: hargaTotal,
          is_item: is_item,
          used_for: used_for,
          id_pp_dtl: id_pp_dtl,
          unit_price: unit_price,
          tax_type: tax_type,
          catatan_dtl: catatan_dtl,
          value_wo: this.collectData.grandtotal,
        };
      } else {
        this.postData = new FormData();
        this.postData.append("tlc", this.getAuth.username);
        this.postData.append("tgl_wo", this.collectData.informasi.tgl_buat);
        this.postData.append("no_pp", this.collectData.informasi.no_pp);
        this.postData.append("id_pp", this.collectData.informasi.id_pp);
        this.postData.append(
          "id_supplier",
          this.collectData.informasi.id_supplier
        );
        this.postData.append("deskripsi", this.collectData.informasi.deskripsi);
        this.postData.append("lokasi", this.collectData.informasi.lokasi);

        this.postData.append("catatan", this.collectData.informasi.catatan ? 
            this.collectData.informasi.catatan : '');
        this.postData.append("tax", this.collectData.informasi.tax);
        this.postData.append(
          "tgl_pekerjaan",
          this.collectData.informasi.tgl_buat
        );
        this.postData.append("bod", this.collectData.informasi.bod);

        this.collectData.listWO.forEach((data, index) => {
          this.postData.append("job[]", data.values.item_name);
          this.postData.append("qty[]", data.values.jumlah);
          this.postData.append("satuan[]", data.values.satuan);
          this.postData.append("harga[]", data.values.harga);
          this.postData.append(
            "hargaTotal[" + index + "]",
            data.values.hargaTotal
          );
          this.postData.append("is_item[" + index + "]", data.values.is_item);
          this.postData.append("used_for[" + index + "]", data.values.used_for);
          this.postData.append(
            "id_pp_dtl[" + index + "]",
            data.values.selectedPPdtl
          );
          this.postData.append(
            "unit_price[" + index + "]",
            data.values.cur_type
          );
          this.postData.append("tax_type[]", data.values.tax_type);
          this.postData.append("catatan_dtl[]", data.values.catatan_dtl);
          this.postData.append("tax_bearer[]", data.values.tax_bearer);
        });

        this.postData.append("value_wo", this.collectData.grandtotal);
      }
    },
    submit() {
      if (this.collectData.emptyValidator == 0) {
        this.displayMessage("empty-phurcaselist");
        return;
      }

      this.setSubmitForm();
      this.btnLoading = true;
      let method = "";
      let data;
      let urlVal = "";

      if (this.mode === "Create") {
        method = "post";
        data = this.postData;
        urlVal = "wo/v2";
      } else {
        method = "post";
        data = this.postJson;
        urlVal = "wo/edit_v2";
      }

      for (var pair of this.postData.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }

      axios({
        method: method,
        url: this.$serviceUrl + urlVal,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            if (response.data.message === "Has been created") {
              this.displayMessage("success-save");
            } else if (
              response.data.message === "transaksi tak memiliki work flow"
            ) {
              this.displayMessage("error-ppproyek");
            } else if (response.data.message === "Saldo PP tidak cukup!") {
              this.displayMessage("error-saldopp");
            }
          } else {
            this.displayMessage("success-edit");
          }
          this.btnLoading = false;
          this.current = 0;
          this.$destroy();
          this.$router.go(-1);
        })
        .catch((err) => {
          this.btnLoading = false;
          let responses = Object.assign({}, err.response.data);
          if (responses.message === "Saldo PP tidak cukup!") {
            let sisa = this.formatCurrency(this.mata_uang, responses.saldo);
            this.displayMessageValue("pp-notenough", sisa);
          } else if (responses.message) {
            this.displayMessageValue("error-other", responses.message);
          } else {
            this.displayMessageValue("error", responses);
          }
        });
    },
    fetchDetail() {
      axios({
        method: "get",
        url: this.$serviceUrl + "wo/wo_Detil_v2",
        params: {
          id_manifest: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            informasi: response.data.informasi,
            keuangan: response.data.keuangan,
            listWO: response.data.detail_wo,
          };
          this.mata_uang = response.data.currency;
          response.data.keuangan.forEach((item) => {
            this.mata_uang = item.currency;
          });

          response.data.detail_wo.forEach((item) => {
            this.listWO = [...this.listWO, { values: item }];
          });
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    setListPekerjaanEmpty() {
      this.listWO = [];
    },
    async getApproval(){
      let params = null;
      if (this.mode=="Create"){
        params = {
          tlc : this.getAuth.username,
          id_pp : this.collectData.informasi.id_pp,
          value_wo : this.collectData.grandtotal,
        }
      }else{
        params = {
          tlc : this.getAuth.username,
          id_pp : this.collectData.informasi.id_pp,
          value_wo : this.collectData.grandtotal,
          id_wo : this.id,
        }
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "wo/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
  },
  mounted() {
    Event.$on("woData", this.valueFromChild);
    Event.$on("listWO", this.getListWO);
    Event.$on("updateList", this.getUpdatePekerjaan);
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("emptylistPekerjaan", this.setListPekerjaanEmpty);
  },
  beforeDestroy() {
    Event.$off("woData", this.valueFromChild);
    Event.$off("listWO", this.getListWO);
    Event.$off("updateList", this.getUpdatePekerjaan);
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("emptylistPekerjaan", this.setListPekerjaanEmpty);
  },
};
</script>

<style>
</style>